import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Category } from '../types/contractor';

// Fallback icon when a category name doesn't match a known mapping
const categoryIcon = (name: string): string => {
  const map: Record<string, string> = {
    'general building': 'foundation',
    'renovation': 'home_repair_service',
    'residential': 'house',
    'commercial': 'apartment',
    'design-and-build': 'architecture',
    'design and build': 'architecture',
    'other services': 'grid_view',
    'plumbing': 'plumbing',
    'electrical': 'electrical_services',
    'roofing': 'roofing',
    'painting': 'format_paint',
    'flooring': 'layers',
  };
  return map[name.toLowerCase()] ?? 'construction';
};

interface QuickCategoriesProps {
  categories: Category[];
}

const QuickCategories: React.FC<QuickCategoriesProps> = ({ categories }) => {
  const navigate = useNavigate();

  if (categories.length === 0) return null;

  const visible = categories.slice(0, 6);

  return (
    <section className="px-container-margin md:py-16 max-w-7xl mx-auto">
      <div className="flex items-center justify-between mb-stack-md md:mb-10">
        <h2 className="font-headline-sm text-headline-sm-mobile md:font-headline-md md:text-headline-md text-primary md:text-center">
          Quick Categories
        </h2>
        <Link
          to="/categories"
          className="font-label-bold text-sm text-primary hover:underline flex-shrink-0"
        >
          View all
        </Link>
      </div>
      <div className="flex gap-stack-md overflow-x-auto pb-stack-sm no-scrollbar md:grid md:grid-cols-2 lg:grid-cols-6 md:gap-gutter">
        {visible.map((cat, i) => (
          <button
            key={cat.id}
            onClick={() => navigate(`/contractors?categoryId=${cat.id}`)}
            className={`flex-shrink-0 px-6 py-3 rounded-full font-label-bold flex items-center gap-2 shadow-sm transition-transform active:scale-95 md:bg-white md:p-6 md:rounded-xl md:shadow-sm md:border md:border-outline-variant/20 md:flex-col md:items-center md:gap-3 md:hover:shadow-md md:hover:border-secondary md:cursor-pointer ${
              i === 0
                ? 'bg-secondary-container text-on-secondary-container'
                : 'bg-surface-container-high text-on-surface-variant hover:bg-surface-container-highest transition-colors'
            }`}
          >
            <div className="md:w-12 md:h-12 md:bg-secondary-container/20 md:rounded-full md:flex md:items-center md:justify-center">
              <span className="material-symbols-outlined md:text-secondary" data-icon={categoryIcon(cat.name)}>
                {categoryIcon(cat.name)}
              </span>
            </div>
            {cat.name}
          </button>
        ))}
      </div>
    </section>
  );
};

export default QuickCategories;
